<script>
    import { onMount, beforeUpdate, onDestroy  } from "svelte";
    import { db, activeConversation, userID, clientUserID, selectedMode, isModesToggleExpanded, emailHash, socketStore, isStreaming, isStatelessUserFlag, statelessMessages, daChatToken, daMessageId, addStatelessMessage, isCollapsed, } from "../stores.js";
    import { v4 as uuidv4 } from 'uuid';
    import { io } from 'socket.io-client';
    import { baseURL, wssURL } from "../config.js"

//Take revenge and get the fucking smooth transition of the textarea box later. Admit defeat now.

//    let isStreaming = false;
      let isProcessing = false;



  function updateSafeAreaInsets() {
    const safeAreaInsetBottom = getComputedStyle(document.body).getPropertyValue('safe-area-inset-bottom') || '2%';
    document.documentElement.style.setProperty('--safe-area-inset-bottom', safeAreaInsetBottom);
  }


    onMount(() => {
    window.addEventListener('resize', updateSafeAreaInsets);
    updateSafeAreaInsets(); // Update on component mount
        setTimeout(adjustHeight, 50);
    });

  onDestroy(() => {
    window.removeEventListener('resize', updateSafeAreaInsets);
  });




    // Function to check if the device is in portrait mode and log the state
    const isPortrait = () => {
        const portrait = window.matchMedia("(orientation: portrait)").matches;
        console.log(`Checking orientation: ${portrait ? 'Portrait' : 'Landscape'}`);
        return portrait;
    };

    // Initial check and log
    let portraitMode = isPortrait();

    // Reactive statements to apply classes based on isCollapsed and orientation
//    $: splashScreenClass = !$isCollapsed && portraitMode ? 'hidden' : '';
//    $: textAreaClass = $isCollapsed || !portraitMode ? 'no-interaction' : '';
    $: unifiedClassName = !$isCollapsed && portraitMode ? 'hidden no-interaction' : '';

    $: {
        portraitMode = isPortrait(); // Re-check whenever dependencies change
        console.log(`isCollapsed: ${$isCollapsed}, portraitMode: ${portraitMode}`);
    }

    // Ensure updates on orientation change or window resize
    window.addEventListener('resize', () => {
        portraitMode = isPortrait(); // Update the state and log
    });



    let styleOverrides = ''; // Initially define the variable outside the reactive block
    $: {
        const fadeOutDuration = '0.1s'; // Longer fade out
        const fadeInDuration = '0.9s'; // Quicker fade in
        styleOverrides = !$isCollapsed && portraitMode 
                         ? `opacity: 0; visibility: hidden; --fade-duration: ${fadeOutDuration};`
                         : `opacity: 1; visibility: visible; --fade-duration: ${fadeInDuration};`;
        console.log(`Style applied: ${styleOverrides}`);
    }












    let inputText = "";

    function handleEnter(event) {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();  // Prevents the default action of the Enter key
            sendMessage();
        }
    }


    let textarea;
    let socket; // Socket.IO connection, moved outside the sendMessage function
    let lol = "5b700fad00a8570e62945e7b3f72fae7:6438831a18646c395ba7124c3e39f72d705b4fa02155dd7eb03cf79bdf0dc5de67f5f6580789a634e3fd76d2100263ec0832c488b44c029d225cf6a5be9088fb52f1f67487e6b10d9e09aab778599bc97aa56db174d7a064d37e8766e4e1baf5db8ba0d826fc76478a930967d905549a00d7d6b07afa812f001818b5f9d710642b0c22ee77e0b1bb677613fc8094fe0c121be93fc980b89383216744970bbf71c18c396a26d4d89401233218b31863b52648fbea83d26a2d24a1fd87c25d86b6f7bbb94cae282b77815a935e4833b9e0aafd763f6a66e738422f9bdaddefa57b797413489056848e35d6933c68ec853ddac2d150bedc32ef856ab344dfa9b49b82ef93205fef35916c4dd9ca86b653293463d39b58220c49fc168c7feb1792ec8edc910379663c2402ec8aa71214ba50c5230767d852943b9c4652bd94bb69cbae5598b717c8a83b3a31c4af9554799a2940f480958173d678e62221f3693e75187df08fe2e24f919a80b2830ded46446ab2c9e71a3a93c481d8b74d4336868450e60301f1abab14c20ec987edd93026bfac63b93f22533381863c8703fbd2148243e84aa50084a01fa4bed4c071b9bb747428b96e2d49596a08aee2bad1acb373e576ce6e5031ebc9eda9d96d6b7904cf11bed2ac3bf345409a986381e57b3e8fb05b3c190bf250ca1909d1bc545aaa6aa50124f06d5849f8b61f7d418919bbc2ea3ac90935ff7c820833873d3f8042f8aed0a3231e67d18e2b9dcce4deb250d07d13ddd1767475c5671d7e0eac47a8bb0a690709b525494f7ab83c141d6d191020ff4b59728dd934c185d1e0053bb8da996154fd28aa34339270223cfeb6c7224207648e7d8889a9c65fabe4443b21960b75f9c1cdd5a19e3584c4ccb58bfd2d179c30fa2277c6f7fe0597f4c23d97f62af03712cf168381aac5d2f4cdaff59bcf41d3a982f2f8cf9579c9d0765c96"


    async function sendMessageOld() {
        if (inputText.trim() !== "") {
            const currentConversationId = $activeConversation;
            const messageId = uuidv4(); // Generate a unique message ID


        // Create Firestore document for message status
        const messageStatusRef = $db.collection('messageStatuses').doc(messageId);
        await messageStatusRef.set({
            status: 'received...',
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            lastModified: firebase.firestore.FieldValue.serverTimestamp(),
        });
        // Update the conversation document with the active status ID
        const conversationRef = $db
            .collection("users").doc($userID)
            .collection("deploymentUserData").doc($clientUserID)
            .collection("clientSubUsers").doc($emailHash)
            .collection("conversations").doc(currentConversationId);

        await conversationRef.update({
            activeMessageStatusId: messageId
        });
        

            const data = {
                userId: $userID,
                clientUserId: $clientUserID,
                conversationId: currentConversationId,
                messageId, // Include the messageId
                emailHash: $emailHash,
                aimodel: "gpt-4-1106-preview",
                message: inputText,
                modeId: $isModesToggleExpanded && $selectedMode && $selectedMode.id ? $selectedMode.id : null
            };



            // Clear the input field
            inputText = "";

            // Ensure DOM updates have been processed before adjusting height
            Promise.resolve().then(() => {
                adjustHeight();
            });




            try {
                const response = await fetch(
                    `${baseURL}/api/raccaRacca`,
                    {
                        method: "POST",
                        mode: "cors",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(
                        `Server responded with ${response.status}: ${errorData.message}`
                    );
                }
                console.log("Message sent succesfully");
            } catch (error) {
                console.error("Error:", error);
                await messageStatusRef.update({
                    status: 'error',
                    errorTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
                });
                alert("Error during message sent:", error);
            }
        }
    }

    function connectToWebsocket(eData) {
        try { 
        socket = io(wssURL, {
            query: {
                encryptedData: eData
            },
            autoConnect: false, // Prevent automatic connection upon instantiation
            reconnection: false, // Prevent automatic reconnection
        });
        // Manually open the connection
        socket.connect();

        socket.on('disconnect', () => {
            console.log('Disconnected from server');
            socket = null; // Reset the local socket variable
            socketStore.set(null); // Also update the Svelte store to reflect the disconnection
        });

        // Update the Svelte store with the new socket instance
        socketStore.set(socket);

        return socket;
    } catch (error) {
        console.log("This is error:", error);
    }
    }


    async function sendMessage_wsOld() {
        //let socket; // Socket.IO connection, but we've moved it to outer-scope now that's why it's commented out
        const establishConnection = () => {
            console.log("Establishing connection...");

            socket = connectToWebsocket();

            /*// Handling incoming messages from the server
            socket.on('chatMessage', (payload) => {
                //console.log('Message from server:', payload);
                if (payload && payload.event === 'done') {
                    console.log('Stream ended at FROM TIA:', new Date().toISOString());
                    //stopStreamButton.classList.add('hidden'); // Hide the stop button
                } else {
                    try {
                        if (payload.data && payload.data.choices && payload.data.choices.length > 0 && payload.data.choices[0].delta && payload.data.choices[0].delta.content) {
                            //appendParsedMessage(payload.data.choices[0].delta.content);
                            console.log('Received data FROM TIA:', payload.data.choices[0].delta.content);
                        }
                    } catch (e) {
                        console.error('Error parsing data:', e);
                        //stopStreamButton.classList.add('hidden'); // Hide the stop button
                    }
                }
            });

            // Handling connection errors
            socket.on('disconnect', () => {
                console.log('Disconnected from server');
                socket = null; // Reset the socket variable
                stopStreamButton.classList.add('hidden'); // Hide the stop button
            });

            socket.on('connect_error', (error) => {
                console.error('Connection error:', error);
                socket = null; // Reset the socket variable
                stopStreamButton.classList.add('hidden'); // Hide the stop button
            });

            socket.on('stream_error', (error) => {
                console.error('Stream error:', error);
                stopStreamButton.classList.add('hidden'); // Hide the stop button
            });
            */
        };


        console.log('Stream request sent at:', new Date().toISOString());
        if (!socket) {
            establishConnection(); // Establish connection if not already connected
        }
        socket.emit('streamTakeDown', lol);
    }



////////////

function transformMessages(originalMessages) {
    return originalMessages.map(message => ({
        role: message.type,
        content: message.text
        // modeId and messageId are omitted to match the desired structure
    }));
}



    async function sendMessage() {
            if (isProcessing) return; // Do nothing if isProcessing is true
            if (inputText.trim() !== "") {
                isProcessing = true; // Show the intermediary animation
                const currentConversationId = $activeConversation;
                const messageId = uuidv4(); // Generate a unique message ID

            const originalMessages = $statelessMessages;  // Get the current value of the store

            const daMessAGES = transformMessages(originalMessages);

            const dinputTEXT = inputText;
        

            const data = {
                userId: $userID,
                clientUserId: $clientUserID,
                conversationId: currentConversationId,
                messageId: messageId, // Include the messageId
                emailHash: $emailHash,
                message: inputText,
                modeId: $isModesToggleExpanded && $selectedMode && $selectedMode.id ? $selectedMode.id : null
            };

            const data2 = {
                message: inputText,
                messages: daMessAGES,
                messageId: messageId, // Include the messageId
                chatToken: $daChatToken,
                modeId: $isModesToggleExpanded && $selectedMode && $selectedMode.id ? $selectedMode.id : null
            };

            let authToken;
            if ($isStatelessUserFlag) {
                authToken = await firebase.auth().currentUser.getIdToken(true); // true ensures the token is refreshed
            }

            // Clear the input field
            inputText = "";

            // Ensure DOM updates have been processed before adjusting height
            Promise.resolve().then(() => {
                adjustHeight();
            });


            let messageStatusRef;
            if ($isStatelessUserFlag) {

                addStatelessMessage({ 
                    type: 'user', 
                    text: dinputTEXT, 
                    modeId: $isModesToggleExpanded && $selectedMode && $selectedMode.id ? $selectedMode.id : null, 
                    messageId: messageId 
                });

                daMessageId.set(messageId);
                messageStatusRef = $db.collection('messageStatusesSTATELESS').doc(messageId);
                await messageStatusRef.set({
                    status: 'received...',
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    lastModified: firebase.firestore.FieldValue.serverTimestamp(),
                });
            } else {

                // Create Firestore document for message status
                messageStatusRef = $db.collection('messageStatuses').doc(messageId);
                await messageStatusRef.set({
                    status: 'received...',
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    lastModified: firebase.firestore.FieldValue.serverTimestamp(),
                });
                // Update the conversation document with the active status ID
                const conversationRef = $db
                    .collection("users").doc($userID)
                    .collection("deploymentUserData").doc($clientUserID)
                    .collection("clientSubUsers").doc($emailHash)
                    .collection("conversations").doc(currentConversationId);

                await conversationRef.update({
                    activeMessageStatusId: messageId
                });
            }



            try {
                const endpoint = $isStatelessUserFlag ? 'stateless-raccaRacca2' : 'raccaRacca2';
                const headers = {
                    "Content-Type": "application/json",
                    ...(authToken ? { 'Authorization': `Bearer ${authToken}` } : {}) // Conditionally add Authorization header
                };

                const response = await fetch(
                    `${baseURL}/api/${endpoint}`,
                    {
                        method: "POST",
                        mode: "cors",
                        headers: headers,
                        body: JSON.stringify($isStatelessUserFlag ? data2 : data)
                    }
                );

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(
                        `Server responded with ${response.status}: ${errorData.message}`
                    );
                }
                const responseData = await response.json(); // Parse the JSON body of the response
                if (responseData && responseData.encryptedData) {
                    const resEData = responseData.encryptedData;
                    const headEData = responseData.headerData;

/*                    const establishConnection = () => {
                        console.log("Establishing connection...");
                        socket = connectToWebsocket(headEData);
                        socket.on('disconnect', () => {
                            console.log('Disconnected from server');
                            socket = null; // Reset the socket variable
                            socketStore.set(null); // Update the Svelte store to reflect the disconnection
                        });
                    };*/
                    isProcessing = false; // Show the intermediary animation
                    isStreaming.set(true);
                    console.log('Stream request sent at:', new Date().toISOString());
                    if (!socket) {
                        //establishConnection(); // Establish connection if not already connected
                        socket = connectToWebsocket(headEData); // This now correctly affects the outer 'socket'
                    }
                    socket.emit('streamTakeDown', resEData);

                } else {
                    console.error("Res was sent and returned but no encrptedData?");
                }

            } catch (error) {
                console.error("Error:", error);
                /*await messageStatusRef.update({
                    status: 'error',
                    errorTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
                });*/
                await messageStatusRef.delete();

                alert("Error during message sent:", error);
            }
        }
    }


    function stopStream() {
        if (isProcessing) return; // Do nothing if isProcessing is true
        if ($socketStore) {
            $socketStore.emit('stopStream');
            console.log('Stop stream request sent');
            isStreaming.set(false); // Optionally reset the streaming state
        }
    }





//////////


function adjustHeight() {
    textarea.style.overflowY = "hidden"; // Hide scrollbar during adjustment
    textarea.style.height = "0px"; // Collapse the textarea to reset its height
    
    const scrollHeight = textarea.scrollHeight;
    const maxHeight = 24 * 7; // Adjust this line to match your desired max height
    const newHeight = Math.min(scrollHeight, maxHeight);
    
    textarea.style.height = `${newHeight}px`; // Apply the new height
    
    if (newHeight >= maxHeight) {
        textarea.style.overflowY = "auto"; // Re-enable scrolling if needed
    }
}







</script>

<!-- <div class="textarea-wrapper {unifiedClassName}"> -->
<div class="textarea-wrapper" style={styleOverrides}>
    <textarea
        bind:this={textarea}
        on:input={adjustHeight}
        bind:value={inputText}
        on:keydown={handleEnter}
        placeholder="Send a message"
        rows="1"
    />

    <div class="send-icon" class:processing={isProcessing} 
         on:click={isProcessing ? null : ($isStreaming ? stopStream : sendMessage)}>

        {#if $isStreaming}
            <!-- Stop Button SVG -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="h-2 w-2 text-token-text-primary" height="20" width="20">
                <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"></path>
            </svg>
        {:else if isProcessing}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="20" height="20" style="shape-rendering: auto; display: block; background: transparent;" xmlns:xlink="http://www.w3.org/1999/xlink"><g><circle cx="84" cy="50" r="10" fill="#101010">
    <animate attributeName="r" repeatCount="indefinite" dur="0.25s" calcMode="spline" keyTimes="0;1" values="10;0" keySplines="0 0.5 0.5 1" begin="0s"></animate>
    <animate attributeName="fill" repeatCount="indefinite" dur="1s" calcMode="discrete" keyTimes="0;0.25;0.5;0.75;1" values="#101010;#9c9c9c;#131313;#585858;#101010" begin="0s"></animate>
</circle><circle cx="16" cy="50" r="10" fill="#101010">
  <animate attributeName="r" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s"></animate>
  <animate attributeName="cx" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="0s"></animate>
</circle><circle cx="50" cy="50" r="10" fill="#585858">
  <animate attributeName="r" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.25s"></animate>
  <animate attributeName="cx" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.25s"></animate>
</circle><circle cx="84" cy="50" r="10" fill="#131313">
  <animate attributeName="r" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.5s"></animate>
  <animate attributeName="cx" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.5s"></animate>
</circle><circle cx="16" cy="50" r="10" fill="#9c9c9c">
  <animate attributeName="r" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="0;0;10;10;10" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.75s"></animate>
  <animate attributeName="cx" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.25;0.5;0.75;1" values="16;16;16;50;84" keySplines="0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.75s"></animate>
</circle><g></g></g><!-- [ldio] generated by https://loading.io --></svg>

        {:else}
            <!-- Airplane Button SVG -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" width="20" height="20">
                <path d="M.5 1.163A1 1 0 0 1 1.97.28l12.868 6.837a1 1 0 0 1 0 1.766L1.969 15.72A1 1 0 0 1 .5 14.836V10.33a1 1 0 0 1 .816-.983L8.5 8 1.316 6.653A1 1 0 0 1 .5 5.67V1.163Z" fill="currentColor"></path>
            </svg>
        {/if}
    </div>

</div>

<style>
    .textarea-wrapper {
        position: absolute; /* position relative to the chat-area */
        bottom: var(--safe-area-inset-bottom, 2%); /* Use the safe area inset or fallback to 2% */
        left: 50%; /* centering */
        transform: translateX(-50%);
        width: 60vw;
        max-width: 40vw;
        z-index: 10;
/*this animation*/
        transition: opacity var(--fade-duration, 0.3s) ease-in-out, 
                    visibility var(--fade-duration, 0.3s) ease-in-out;
        opacity: 1; /* Start fully visible */
        visibility: visible; /* Start visible */
    }

    .no-interaction {
        pointer-events: none;
        opacity: 0.5; /* Optional visual feedback */
    }

    textarea {
    width: 100%;
    background-color: var(--messageinput-bg);
    border: 1px solid var(--messageinput-border);
    border-radius: 0.75rem;
    color: var(--textarea-text);
    padding: 16px 40px 16px 16px;
    box-sizing: border-box;
    overflow-y: auto;
    max-height: calc((1.5em * 7) + 2px);
    resize: none;
    scrollbar-width: thin;
    scrollbar-color: lightgrey transparent;
    line-height: 1.5em;
    margin-bottom: -4px;
    font-size: 1rem;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); /* horizontal vertical blur color */
}


    textarea:focus {
        outline: none;
        /* Optionally, you can add a subtle box-shadow or change border color for focus state */
        /* box-shadow: 0 0 5px rgba(0,0,0,0.2); */
    }

    .send-icon {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        z-index: 11;
    }

    .send-icon.processing {
        cursor: default;
    }

/* Media query for devices in portrait orientation */
@media (orientation: portrait) {
    .textarea-wrapper {
        width: 72vw;
        max-width: 72vw;
        margin-bottom: calc(env(safe-area-inset-bottom, 0px) + var(--extra-margin)); /* Safe area inset with conditional additional margin */

    }


}
</style>
